import React, { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";

export default function Lnetwork() {
    // ambil referral code dari URL
    // contoh:
    // https://app.domain.com/invite/ABC123

    const referralCode = useMemo(() => {
        const path = window.location.pathname;
        const segments = path.split("/");
        return segments[segments.length - 1] || "";
    }, []);

    // ganti dengan package app anda
    const androidPackage = "com.hijrahgroup.networkclub";

    // ganti dengan app store url anda
    const iosAppStoreUrl =
        "https://apps.apple.com/id/app/your-app/id123456789";

    // redirect playstore dengan install referrer
    const playStoreUrl = `https://play.google.com/store/apps/details?id=${androidPackage}&referrer=utm_source%3Dinvite%26utm_campaign%3D${referralCode}`;

    useEffect(() => {
        const userAgent = navigator.userAgent || navigator.vendor;

        // auto redirect android
        if (/android/i.test(userAgent)) {
            setTimeout(() => {
                window.location.href = playStoreUrl;
            }, 1500);
        }

        // auto redirect ios
        // else if (/iPad|iPhone|iPod/.test(userAgent)) {
        //     setTimeout(() => {
        //         window.location.href = iosAppStoreUrl;
        //     }, 1500);
        // }
    }, [playStoreUrl, iosAppStoreUrl]);

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <img
                    src="/assets/icon_network.png"
                    alt="Logo"
                    style={styles.logo}
                />

                <h1 style={styles.title}>L'Network</h1>

                <p style={styles.subtitle}>
                    Anda diundang bergabung menggunakan kode referral:
                </p>

                <div style={styles.referralBox}>
                    {referralCode}
                </div>

                <p style={styles.description}>
                    Dapatkan cashback, benefit member, dan berbagai keuntungan lainnya 🚀
                </p>

                <div style={styles.buttonGroup}>
                    <a
                        href={playStoreUrl}
                        style={styles.androidButton}
                    >
                        Download Android
                    </a>

                    {/* <a
                        href={iosAppStoreUrl}
                        style={styles.iosButton}
                    >
                        Download iPhone
                    </a> */}
                    <a
                        href="#"
                        style={styles.iosButtonDisabled}
                        onClick={(e) => e.preventDefault()}
                    >
                        iPhone Coming Soon
                    </a>
                </div>

                <p style={styles.note}>
                    Anda akan diarahkan otomatis ke store...
                </p>
            </div>
        </div>
    );
}

const styles = {
    container: {
        minHeight: "100vh",
        background: "#0f172a",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 20,
        fontFamily: "Arial, sans-serif",
    },

    card: {
        width: "100%",
        maxWidth: 420,
        background: "#ffffff",
        borderRadius: 24,
        padding: 32,
        textAlign: "center",
        boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
    },

    logo: {
        width: 90,
        marginBottom: 20,
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
    },

    title: {
        fontSize: 32,
        marginBottom: 10,
        color: "#111827",
    },

    subtitle: {
        color: "#6b7280",
        marginBottom: 16,
        fontSize: 16,
    },

    referralBox: {
        background: "#f3f4f6",
        padding: "14px 20px",
        borderRadius: 14,
        fontSize: 28,
        fontWeight: "bold",
        letterSpacing: 2,
        marginBottom: 20,
        color: "#2563eb",
    },

    description: {
        fontSize: 15,
        color: "#4b5563",
        lineHeight: 1.6,
        marginBottom: 28,
    },

    buttonGroup: {
        display: "flex",
        flexDirection: "column",
        gap: 14,
    },

    androidButton: {
        background: "#16a34a",
        color: "#fff",
        textDecoration: "none",
        padding: "14px",
        borderRadius: 14,
        fontWeight: "bold",
        fontSize: 16,
    },

    iosButton: {
        background: "#111827",
        color: "#fff",
        textDecoration: "none",
        padding: "14px",
        borderRadius: 14,
        fontWeight: "bold",
        fontSize: 16,
    },

    iosButtonDisabled: {
        background: "#9ca3af",
        color: "#ffffff",
        textDecoration: "none",
        padding: "14px",
        borderRadius: 14,
        fontWeight: "bold",
        fontSize: 16,
        cursor: "not-allowed",
        opacity: 0.7,
    },

    note: {
        marginTop: 20,
        fontSize: 13,
        color: "#9ca3af",
    },
};